
export enum FONT_STYLE {
  MEDIUM = 'ArchiaMedium',
  BOLD = 'ArchiaBold'
}

export const APP_DATE = 'dd/MM/yyyy';

export enum GIFT_TYPE {
  VUI_POINT = "VUI_POINT",
  BRAND_POINT = "BRAND_POINT"
}

export enum LIKERT_TYPE {
  BAR = 'BAR',
  BOX = 'BOX'
}

interface Choice {
  label: string;
  imageUrl: string;
  defaultAnswer: boolean;
}

interface Question {
  id: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  formId: string;
  pageIndex: number;
  questionNumber: number;
  type: string;
  label: string;
  imageUrl: string;
  required: boolean;
  multipleChoice: boolean;
  customChoice: boolean;
  hasFollowUpQuestion?: boolean;
  followUpQuestion?: string;
  choices?: Choice[];
  depend: boolean;
  questionDependId?: string;
  answerDepend?: string[];
}

interface PageForm {
  title: string;
  imageUrl: string;
  description: string;
  pageIndex: number;
  questions: Question[];
}

interface GiftDetail {
  type: string;
  quantity: number;
  currencyCode?: string;
  currencyName?: string;
  currencyLogo?: string;
}

interface GiftPackages {
  thanksContent: string;
  quantity: number;
  isCheckFraud: boolean;
  giftDetails: GiftDetail[];
}

interface Survey {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  displayName: string;
  displayIntroduction: boolean;
  imageUrl: string;
  description: string;
  type: string;
  noOfSubmittedForm: number;
  status: string;
  userSegmentIds: string[];
  action: string;
  pageForms: PageForm[];
  giftPackages: GiftPackages;
}

export interface AccessTokenData {
  token: string;
  accessToken?: string;
  email: string;
  isNew?: boolean;
  id: string;
  seq: number;
  isActive: boolean;
  displayName: string;
  status?: number;
  ttl: number;
  provider?: string;
  providerId?: string;
}

export interface ResponseStatus {
  success: boolean;
  code: number;
  message: string;
}

export interface APIResponse {
  status: ResponseStatus;
  data?: any;
}

export interface FetchData {
  mobileForm: Survey;
  credential: {
    userId: string;
    leaderboardId: string;
    mobile: string;
    transactionId?: string;
  }
}

const test = {
  id: "81f66ae4-3413-44a6-bf40-dfdc00f421aa",
  name: "Khảo sát đánh giá trải nghiệm của khách hàng",
  startDate: "2024-12-13 14:23:33",
  endDate: "2025-01-31 14:23:35",
  displayName: "Chỉ cần 5s để The Pizza Company hiểu bạn hơn",
  displayIntroduction: true,
  imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/175bc3a3b828b3b25ccac4bd72004a09.png",
  description: "<p><span style=\"color: rgba(0, 0, 0, 0.84); font-size: 14px;\">Chỉ cần 5s để The Pizza Company hiểu hơn về khách ruột </span></p>",
  type: "SURVEY",
  noOfSubmittedForm: 0,
  status: "ENABLE",
  userSegmentIds: [],
  action: "ACCESS_PAGE",
  pageForms: [
    {
      title: "Bạn hãy dành ít phút để làm khảo sát nhận quà nhé ^^",
      imageUrl: "",
      description: "",
      pageIndex: 0,
      questions: [
        {
          id: "bb473b49-f545-4333-adeb-192953c5a471",
          createdAt: "2024-12-13 14:37:34",
          createdBy: "long.d.le",
          updatedAt: "2025-01-06 13:11:17",
          updatedBy: "phi.c.nguyen",
          formId: "81f66ae4-3413-44a6-bf40-dfdc00f421aa",
          pageIndex: 0,
          questionNumber: 1,
          type: "TEXT",
          label: "Bạn tên gì á?",
          imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/086d705b08fc3282e1b3598c7eb336b8.png",
          required: true,
          multipleChoice: false,
          customChoice: false,
          depend: false,
        },
        {
          id: "740d170d-a181-477c-830c-20f50544de77",
          createdAt: "2024-12-13 14:37:34",
          createdBy: "long.d.le",
          updatedAt: "2025-01-06 13:11:17",
          updatedBy: "phi.c.nguyen",
          formId: "81f66ae4-3413-44a6-bf40-dfdc00f421aa",
          pageIndex: 0,
          questionNumber: 2,
          type: "CHOICE",
          label: "Bạn ở tỉnh thành nào?",
          imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/4beb00fe7c240db3668d557f511f3a8b.png",
          required: true,
          multipleChoice: true,
          customChoice: true,
          choices: [
            { label: "TP.HCM", imageUrl: "", defaultAnswer: false },
            { label: "Hà Nội", imageUrl: "", defaultAnswer: false },
            { label: "Đà Nẵng", imageUrl: "", defaultAnswer: false },
            { label: "Cần Thơ", imageUrl: "", defaultAnswer: false },
          ],
          depend: false,
        },
        {
          id: "1e3e11cd-b45f-4d58-9876-3fc74970af96",
          createdAt: "2024-12-13 14:37:34",
          createdBy: "long.d.le",
          updatedAt: "2025-01-06 13:11:17",
          updatedBy: "phi.c.nguyen",
          formId: "81f66ae4-3413-44a6-bf40-dfdc00f421aa",
          pageIndex: 0,
          questionNumber: 3,
          type: "IMAGE",
          label: "Bạn là nam thanh hay nữ tú",
          imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/bd7c96dc3f93b51d1d996b4809bc7b46.png",
          required: true,
          multipleChoice: false,
          customChoice: false,
          choices: [
            {
              label: "Nam",
              imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/7e951dc0b1c919e0f7f1538813b7b18c.png",
              defaultAnswer: false,
            },
            {
              label: "Nữ ",
              imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/dc7aa8c92583ef5e1865ce2d91cb602b.png",
              defaultAnswer: false,
            },
            {
              label: "Khác",
              imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/38eb54f9e0cf4157872d56fd1e2ef4c9.png",
              defaultAnswer: false,
            },
          ],
          depend: true,
          questionDependId: '740d170d-a181-477c-830c-20f50544de77',
          answerDepend: ['TP.HCM']
        },
        {
          id: "1e77a169-5922-4694-999c-a97fce8c1196",
          createdAt: "2024-12-13 14:37:34",
          createdBy: "long.d.le",
          updatedAt: "2025-01-06 13:11:17",
          updatedBy: "phi.c.nguyen",
          formId: "81f66ae4-3413-44a6-bf40-dfdc00f421aa",
          pageIndex: 0,
          questionNumber: 4,
          type: "LIKERT",
          label: "Bạn thấy thế nào về món Pizza của chúng tôi",
          imageUrl: "https://vui-cdn.taptap.vn/stag/media/image/f1c0e70640a898a17a27e63acf43c391.png",
          required: true,
          multipleChoice: false,
          customChoice: false,
          depend: true,
          questionDepend: '740d170d-a181-477c-830c-20f50544de77',
          answerDepend: ['Hà Nội']
        },
      ],
    }
  ],
  giftPackages: {
    thanksContent: "Cảm ơn bạn đã dành thời gian làm đánh giá này",
    quantity: 10000,
    isCheckFraud: false,
    giftDetails: [
      { type: "VUI_POINT", quantity: 10000 },
      {
        type: "BRAND_POINT",
        quantity: 1000,
        currencyCode: "tpcstaging",
        currencyName: "PIZZA XU ",
        currencyLogo: "https://d7efb8x1bjjxk.cloudfront.net/stag/media/image/69c204dcaf0739bafb550c63ba93e813.png",
      },
    ],
  },
};

export default test;
